import { getRandomNumber } from '../helpers/utils';

export const appendStripes = (container, count = 150, min = false) => {
   if (!container) return false;
   let index = 1;
   while (index <= count) {
      const stripe = document.createElement('div');
      stripe.id = `stripe--${index}`;
      stripe.classList.add('stripe', `stripe--${getRandomNumber(1, 6)}`);
      if (min) stripe.classList.add('stripe--min');
      container.appendChild(stripe);
      index++;
   }

   return container.querySelectorAll('.stripe');
};

export const updateStripes = (stripes, progress, header) => {
   const height = header ? header.clientHeight : window.innerHeight;
   const delta = height * progress.toFixed(3);
   stripes.forEach((stripe, index) => {
      const manipulator = (index + 0.25) * 0.3;
      stripe.style.transform = `
         translate(${delta * manipulator}px, ${-delta * manipulator}px) 
         skew(-45deg)
      `;
      stripe.style.height = 100 * progress.toFixed(3) + '%';
   });
};
